import { render, staticRenderFns } from "./InheritSwitch.vue?vue&type=template&id=3195c16a&lang=pug&"
import script from "./InheritSwitch.vue?vue&type=script&lang=js&"
export * from "./InheritSwitch.vue?vue&type=script&lang=js&"
import style0 from "./InheritSwitch.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports